import { apiClient } from "./apiClient";

export const bloomsApi = {
  plants: () => apiClient.get("/bloom/plants").then((r) => r.data),
  calendar: () => apiClient.get("/bloom/calendar").then((r) => r.data),
  observe: (payload) => apiClient.post("/bloom/observe", payload).then((r) => r.data),
};
